import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

type Lang = "en" | "cs";

const LANGS: Lang[] = ["en", "cs"];

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation("common");
  const current = (i18n.resolvedLanguage ?? i18n.language ?? "en").slice(
    0,
    2
  ) as Lang;

  const handleChange = (lang: Lang) => {
    if (lang === current) return;
    void i18n.changeLanguage(lang);
    try {
      window.localStorage.setItem("dstejskal:lang", lang);
    } catch {
      /* ignore quota / privacy mode */
    }
  };

  return (
    <div
      role="group"
      aria-label={t("accessibility.language")}
      className={cn(
        "inline-flex items-center rounded-full border",
        "border-border-subtle bg-bg-elevated/60 p-0.5"
      )}
    >
      {LANGS.map((lang) => {
        const active = lang === current;
        return (
          <button
            key={lang}
            type="button"
            onClick={() => handleChange(lang)}
            aria-pressed={active}
            className={cn(
              "rounded-full px-2.5 py-1 text-[11px] font-semibold",
              "uppercase tracking-[0.14em] transition-all duration-200",
              active
                ? "bg-accent text-bg-base shadow-[0_1px_0_rgba(0,0,0,0.2)_inset]"
                : "text-text-muted hover:text-text-primary"
            )}
          >
            {lang}
          </button>
        );
      })}
    </div>
  );
}
